import { render, staticRenderFns } from "./AccordianItem.vue?vue&type=template&id=5f9c031e&scoped=true&"
import script from "./AccordianItem.vue?vue&type=script&lang=js&"
export * from "./AccordianItem.vue?vue&type=script&lang=js&"
import style0 from "./AccordianItem.vue?vue&type=style&index=0&id=5f9c031e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9c031e",
  null
  
)

export default component.exports